/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: ad7f31f2 (Tue Mar  3 17:44:55 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface FetchEventCategoriesResponseEventTypes
 */
export interface FetchEventCategoriesResponseEventTypes {
  /**
   *
   * @type string
   * @memberof FetchEventCategoriesResponseEventTypes
   */
  name: string
  /**
   *
   * @type number
   * @memberof FetchEventCategoriesResponseEventTypes
   */
  order: number
}

export function FetchEventCategoriesResponseEventTypesFromJSON(
  json: any
): FetchEventCategoriesResponseEventTypes {
  return FetchEventCategoriesResponseEventTypesFromJSONTyped(json, false)
}

export function FetchEventCategoriesResponseEventTypesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchEventCategoriesResponseEventTypes {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: json['name'],
    order: json['order'],
  }
}

export function FetchEventCategoriesResponseEventTypesToJSON(
  value?: FetchEventCategoriesResponseEventTypes | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    order: value.order,
  }
}
